import React, { lazy } from 'react';
import { Footer, GlobalStyles, Filter, Header, Menu } from 'components/';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import {
	Error404,
	Main,
	HotelIntegration,
	BuyerIntegration,
	Method,
	InteractionBetweenSystems,
} from 'containers/';
import { ThemeProvider } from 'styled-components';
import { useMaintainance } from 'hooks';
const Maintainance = lazy(() => import('containers/Maintainance'));

const theme = {
	darkBlue: '#004685',
	lightBlue: '#0270CB',
	lightGray: '#D5E3F0',
	orange: '#FF6B00',
	inputBorderColor: '#80A2C2',
	placeholderColor: '#80A2C2',
	pt: "'PT Sans', sans-serif !important",
	rubik: "'Rubik', sans-serif",
};

const App = () => {
	const location = useLocation();
	const { isWorks, worksDate, worksTimeFrom, worksTimeTo } = useMaintainance();

	if (isWorks === false) return null;

	if (isWorks === 1) return <Maintainance worksDate={worksDate} worksTimeFrom={worksTimeFrom} worksTimeTo={worksTimeTo} />;

	return (
		<ThemeProvider theme={theme}>
			<GlobalStyles />
			<Header />
			<Menu />
			{location.pathname === '/' && <Filter />}
			<Routes>
				<Route path="/error404" element={<Error404 />}/>

				<Route path="/" element={<Main />}/>
				<Route path="/hotel_integration" element={<HotelIntegration/>}/>
				<Route path="/buyer_integration" element={<BuyerIntegration/>}/>
				<Route path="/method/:id" element={<Method/>}/>
				<Route path="/buyer_integration/between_systems" element={<InteractionBetweenSystems/>}/>
				<Route path="*" element={<Navigate replace to="/error404" />} />
			</Routes>
			<Footer />
			<GlobalStyles />
		</ThemeProvider>
	);
};

export default App;
